<template>
  <div
    class="app-checkbox"
    :class="containerClasses"
  >
    <label
      :for="id"
      :class="labelClasses"
      class="app-checkbox__label"
    >
      <input
        :id="id"
        :name="name"
        :value="value"
        :checked="checked"
        :disabled="disabled"
        :aria-disabled="disabled"
        :class="[{ 'cursor-not-allowed': disabled }, inputClasses]"
        type="checkbox"
        class="app-checkbox__input"
        @change="update"
      >
      <span class="app-checkbox__checkmark" />
      <span
        v-if="label"
        class="app-checkbox__text"
        :class="{ 'sr-only': hideLabel }"
        v-text="label"
      />
    </label>
  </div>
</template>

<script type="text/babel">
import FormInputMixin from '../mixins/FormInputMixin'

export default {
  name: 'AppCheckboxInput',
  mixins: [FormInputMixin],
  model: {
    event: 'change',
    prop: 'modelValue',
  },
  props: {
    value: {
      type: [String, Boolean, Number],
      required: false,
      default: false,
    },
    modelValue: {
      type: [String, Boolean, Array],
      required: false,
      default: false,
    },
    trueValue: {
      type: [String, Boolean],
      required: false,
      default: true,
    },
    falseValue: {
      type: [String, Boolean],
      required: false,
      default: false,
    },
    labelPlacementBefore: {
      type: Boolean,
      required: false,
      default: false,
    },
    hideLabel: {
      type: Boolean,
      required: false,
      default: false,
    },
    containerClasses: {
      type: String,
      required: false,
      default: null,
    },
  },
  computed: {
    checked() {
      if (Array.isArray(this.modelValue)) {
        return this.modelValue.includes(this.value)
      }

      return this.modelValue === this.trueValue
    },
  },
  methods: {
    update(event) {
      const isChecked = event.target.checked

      if (Array.isArray(this.modelValue)) {
        const newValue = [...this.modelValue]

        if (isChecked) {
          newValue.push(this.value)
        } else {
          newValue.splice(newValue.indexOf(this.value), 1)
        }

        this.$emit('change', newValue)
      } else {
        this.$emit('change', isChecked ? this.trueValue : this.falseValue)
      }
    },
  },
}
</script>
